import React from "react";
import styled from "@emotion/styled";
import { Colors } from "./colors";
import Button from "./button.jsx";
import TextInput from "./textBox";
import Link from "./link.jsx";
import Alert from "@mui/material/Alert";
class CodeBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      code: "",
      isFocused: false,
      defaultValue: props.value,
      textFail: false,
      alertSeverity: ""
    };
  }
  handleCodeChange = (value) => {
    this.setState({ code: value });
  };

  getAlert = (alertSeverity) => {
    if (alertSeverity == "success"){
      return <Alert severity="success">Sign up was succesful! Redirecting to main page...</Alert>
    } 
    if (alertSeverity == "error"){
      return <Alert severity="error">The code you entered is incorrect, please try again.</Alert>
    } else {
      return <Alert severity="info"></Alert>
    }
  }

  returnToIndex = () => {
    window.location.href = "/";
  };

  checkCode(value) {

    const jsonData = {
      verification_code: value
    };
    fetch(`/api/v1/user/verify`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(jsonData),
    }).then((response) => {
      //check response
      if (response.ok) {
        // Redirect to index and display success message
        this.setState({ alertSeverity: "success" });
        setTimeout(this.returnToIndex, 3000);
      } else {
        // Handle signup failure, show error message
        this.setState({ alertSeverity: "error" });
      }
    });
      
  }
  handleChange = () => {
    this.props.handleVisiblity(false);
  };

  render() {
    const { code, textFail, alertSeverity } = this.state;
    const { sendCode } = this.props;
    return (
      <Overlay>
        <Box>
          <CrossShape onClick={this.handleChange}>
            <HorizontalBar />
            <VerticalBar />
          </CrossShape>
          {this.getAlert(alertSeverity)}
          <h2>Check Your Inbox</h2>
          <Text>
            We've sent a verification code to your email. Please enter the code
            below to confirm your account.
          </Text>
          <TextInput
            style={{ width: "60%" }}
            value={code}
            placeholder={"enter code here..."}
            func={this.handleCodeChange}
            isfailed={textFail}
          />
          <Resend>
            <Link
              linkText="Resend code"
              color={Colors.black}
              onClick={() => sendCode()}
            />
          </Resend>
          <Button
            disable={false}
            title={"Submit"}
            func={() => this.checkCode(code)}
            color={Colors.buttonColor}
            textColor={Colors.white}
            style={{ width: "65%" }}
          />
        </Box>
      </Overlay>
    );
  }
}

const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid ${Colors.black};
  padding: 12px;
  width: 30%;
  border-radius: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${Colors.white};
`;
const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  z-index: 5;
`;
const Resend = styled.div`
  text-align: left;
  width: 60%;
  font-size: 12px;
  margin-bottom: 16px;
`;

const Text = styled.span`
  width: 60%;
  margin-bottom: 16px;
  text-align: center;
`;

const CrossShape = styled.div`
  align-self: end;
  position: relative;
  width: 7px;
  height: 15px;
  cursor: pointer;
  &:hover > div {
    background-color: ${Colors.black};
  }
`;
const CrossBar = styled.div`
  position: absolute;
  width: 4px;
  height: 100%;
  background-color: ${Colors.lightGray};
`;

const HorizontalBar = styled(CrossBar)`
  transform: rotate(45deg);
`;

const VerticalBar = styled(CrossBar)`
  transform: rotate(-45deg);
`;
export default CodeBox;
